<div>
  <custom-grid
    (onDblClickRow)="onDblClick($event)"
    [data]="deputyList"
    [gridColumns]="gridColumns"
    gridToken="deputyList"
    excelFileName="Specifications"
  ></custom-grid>
</div>
